import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/apiClient";
import JobListings from "@/components/JobListings";
import { useEmbedAutoResize } from "@/lib/embed";

export default function EmbedCareers() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/public/tenant/${slug}`).then(({ data }) => setData(data)).catch(() => setError(true));
  }, [slug]);

  const theme = data?.tenant?.embed_theme || "transparent";
  useEffect(() => {
    document.documentElement.style.background = "transparent";
    document.body.style.background = theme === "light" ? "#F5F5F7" : "transparent";
  }, [theme]);

  useEmbedAutoResize([data, error, theme]);

  if (error) return <div className="p-6 text-[#86868B] text-sm">Careers not found.</div>;
  if (!data) return <div className="p-6 text-[#86868B] text-sm">Loading…</div>;

  const t = data.tenant;
  return (
    <div className="p-4" data-testid="embed-careers" data-embed-root>
      <JobListings jobs={data.jobs} accent={t.accent_color || "#007AFF"} layout={t.layout || "card"} embed />
    </div>
  );
}
